import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Card, Tooltip, Button } from 'antd'

import { connect } from 'react-redux'

import IndividualCard from './IndividualCard'
import VoenCard from './VoenCard'

import './index.scss'
import { TabsInfoIco } from "../../../../../modules/CustomIcons";
import { useHistory, useLocation } from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import { getPathnameByIndex } from "../../../../services/helper";
import { checkPermission } from "../../../../services/permission";
import { useTranslation } from 'react-i18next'
import messageList from "assets/locales/translate.json";
import {getMessageLists} from "store/actions/home";


const Cards: React.FC<any> = (props,messageList) => {

  const language = localStorage.getItem("i18nextLng")
  const {t} = useTranslation()
  const [textArray_individual,setTextArray_individual] = useState([])
  const [textArray_Voen,setTextArray_Voen] = useState([])

  const fetchessageData = async () => {

    let lang_text_individual = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.CARD_PERSONAL')?.textAZE :
        language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.CARD_PERSONAL')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.CARD_PERSONAL')?.textENG :"") : "";
    const array_individual = lang_text_individual !== null && lang_text_individual !== undefined ? lang_text_individual.split("|") : [];

    let lang_text_voen = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.CARD_TIN')?.textAZE :
        language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.CARD_TIN')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.CARD_TIN')?.textENG :"") : "";
    const array_voen = lang_text_voen !== null  && lang_text_voen !== undefined  ? lang_text_voen.split("|") : [];

    setTextArray_individual(array_individual);
    setTextArray_Voen(array_voen)
  };
  useEffect(() => {
    fetchessageData()
  }, [messageList,language])

  const TooltipMessageIndividual= `
    ${
      textArray_individual.map((line:any,index:number) => {

        return(

            line.startsWith('http') ?
                `<a href=${line} key=${index} > ${line} </a>`
                :
                `<p key=${index}> ${line} </p>`
        )
      }).join('')
  }`
  const TooltipMessageVoen = `
    ${
      textArray_Voen.map((line:any,index:number) => {

        return(

            line.startsWith('http') ?
                `<a href=${line} key=${index} > ${line} </a>`
                :
                `<p key=${index}> ${line} </p>`
        )
      }).join('')
  }`
  const tabInnerData: Array<any> = [
    {
      index: 1,
      title: t("businessCards.onIndividual"),
      description: TooltipMessageIndividual ,
      content: <IndividualCard oldBusinessCardsData={props.oldBusinessCardsData} updateOldCard={props.updateOldCard}/>,
      path: '/business_cards/cards/individual_card',
      permissionKey: 'ALL',
    },
    {
      index: 2,
      title: t("businessCards.byTIN"),
      description: TooltipMessageVoen ,
      content: <VoenCard newBusinessCardsData={props.newBusinessCardsData} updateNewCard={props.updateNewCard}/>,
      path: '/business_cards/cards/voen_card',
      permissionKey: 'ALL',
    },
  ];

  const { TabPane } = Tabs;

  const history = useHistory();
  const location = useLocation();
  const find_tab = tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
  const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);

  useEffect(() => {
    const find_tab = tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));

    setTabActiveKey(find_tab?.index);

  }, [location])

  const tabOnChange = (activeKey) => {
    setTabActiveKey(old_key => activeKey);

    const find_row = tabInnerData.find(row => row.index == activeKey);

    if (find_row) {
      history.push(find_row.path);
    }
  };

  useEffect(() => {

    // if (props?.cardStatus?.oldCard === 'true' && props?.cardStatus?.newCard === 'false') {

    if (props?.cardStatus?.oldCard === 'true') {

      setTabActiveKey(old_key => 1);

      const find_row = tabInnerData.find(row => row.index == 1);

      if (find_row) {
        history.push(find_row.path);
      }
    } else if (props?.cardStatus?.oldCard === 'false' && props?.cardStatus?.newCard === 'true') {
      setTabActiveKey(old_key => 2);

      const find_row = tabInnerData.find(row => row.index == 2);

      if (find_row) {
        history.push(find_row.path);
      }
    }
  }, [props.cardStatus])

  return (
    <Row>
      <Col span={24}>
        <Tabs
          activeKey={`${tabActiveKey}`}
          onChange={tabOnChange}
          id="transferTab"
          destroyInactiveTabPane={true}
        >
          {tabInnerData &&
            tabInnerData.map((item, index) => {
              let span_class = (tabInnerData.length - 1 == index) ? 'is_last_span' : '';
              return checkPermission(item.permissionKey) && (
                <TabPane className={span_class} 
                tab={
                  props?.cardStatus?.oldCard === 'false' && props?.cardStatus?.newCard === 'true' ?
                  <></> :
                  <span className={`transfer_child_tabs_${item.index} ${span_class}`} >
                    {item.title}

                    <CustomTooltip
                      title={item.description}
                    >
                      <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                    </CustomTooltip>

                  </span>} 
                  key={item.index}>
                  {item.content}

                </TabPane>
              )
            })}
        </Tabs>
      </Col>
    </Row>
  )
}
const mapDispatchToProps = {
  getMessageLists
}
const mapStateToProps = (state: any) => ({
  messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(Cards)

